/**
 * メニューアクション
 *
 * @param {boolean} change_data     編集中フラグ
 * @param {number} move_function    移動先番号
 * @author hayakawa 2023.10.18
 */

// インポート
import { move_no_master, move_no_setting, move_no_predict, move_no_shift, move_no_expenses, move_no_work, move_no_logout } from './_constants';

// 定数
const $modal_check_move_page = $('#modal-check-move-page');

// 処理
$(function() {
    // マスターメニュークリック
    $('#main-menu-master, #sub-menu-master, #header-menu-master').on('click', function() {
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        if (change_data) {
            move_function = move_no_master;
            $modal_check_move_page.modal('show');
        } else {
            window.location.href = `${MENU_MASTER}`;
        }
    });

    // 設定メニュークリック
    $('#main-menu-setting, #sub-menu-setting, #header-menu-setting').on('click', function() {
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        if (change_data) {
            move_function = move_no_setting;
            $modal_check_move_page.modal('show');
        } else {
            window.location.href = `${MENU_SETTING}`;
        }
    });

    // 予測メニュークリック
    $('#main-menu-predict, #sub-menu-predict, #header-menu-predict').on('click', function() {
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        if (change_data) {
            move_function = move_no_predict;
            $modal_check_move_page.modal('show');
        } else {
            window.location.href = `${MENU_PREDICT}`;
        }
    });

    // シフトメニュークリック
    $('#main-menu-shift, #sub-menu-shift, #header-menu-shift').on('click', function() {
        if (change_data) {
            move_function = move_no_shift;
            $modal_check_move_page.modal('show');
        } else {
            window.location.href = `${MENU_SHIFT}`;
        }
    });

    // 日計表メニュークリック
    $('#main-menu-expenses, #sub-menu-expenses, #header-menu-expenses').on('click', function() {
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        if (change_data) {
            move_function = move_no_expenses;
            $modal_check_move_page.modal('show');
        } else {
            window.location.href = `${MENU_EXPENSES}`;
        }
    });

    // 労務管理表メニュークリック
    $('#main-menu-work, #sub-menu-work, #header-menu-work').on('click', function() {
        if ($(this).hasClass('is-view-mode')) {
            return false;
        }

        if (change_data) {
            move_function = move_no_work;
            $modal_check_move_page.modal('show');
        } else {
            window.location.href = `${MENU_WORK}`;
        }
    });

    //ログアウトメニュー
    $('#header-menu-logout').on('click',function() {
        if (change_data) {
            move_function = move_no_logout;
            $modal_check_move_page.modal('show');
        }
    })
});
